import ConfirmPopup from './ConfirmPopup';

export default ConfirmPopup;
